<template>
  <ResourceDialog
    @cancel="choiceSelected(false)"
    @save="choiceSelected(true)"
    ref="confirmResourceDialog"
    :cancel-button-text="localValue.cancelButtonText"
    :save-button-color="localValue.saveButtonColor"
    :save-button-text="localValue.confirmButtonText"
    :title="localValue.title"
    cancellable
    scrim
  >
    <template #description>
      <p>
        {{ $bct(description) }}
      </p>
    </template>
  </ResourceDialog>
</template>

<script setup>
import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';

const $bct = inject('translator');

let resolveChoice = null;

const confirmResourceDialog = ref(null);
const description = ref('');
const localValue = ref({
  title: null,
  confirmButtonText: 'Confirm',
  cancelButtonText: 'Cancel',
  saveButtonColor: 'primary',
});

defineExpose({ confirmWithText });

function choiceSelected(choiceBoolean) {
  if (!resolveChoice) return;
  resolveChoice(choiceBoolean);

  confirmResourceDialog.value.close();
}

function confirmWithText(
  confirmationText,
  { title, confirmButtonText, cancelButtonText, saveButtonColor } = {},
) {
  if (title) localValue.value['title'] = title;
  if (confirmButtonText) localValue.value['confirmButtonText'] = confirmButtonText;
  if (cancelButtonText) localValue.value['cancelButtonText'] = cancelButtonText;
  if (saveButtonColor) localValue.value['saveButtonColor'] = saveButtonColor;

  confirmResourceDialog.value.open();
  description.value = confirmationText;

  return new Promise((resolve) => {
    resolveChoice = resolve;
  });
}
</script>
